// Marksheet.jsx

import React, { useState } from "react";
import InfoIcon from "../../../assets/img/i-info-gray-filled-icon.png";
import TextInput from "../TextInput";
import Dropdown from "../Dropdown";

const Marksheet = () => {
  const [qualificationDegree, setQualificationDegree] = useState("");
  const [institution, setInstitution] = useState("");
  const [qualification, setQualification] = useState("");
  const [courseName, setCourseName] = useState("");
  const [modeOfQualification, setModeOfQualification] = useState("");
  const [location, setLocation] = useState("");
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [marksheetSections, setMarksheetSections] = useState(1); // State to track the number of marksheet sections

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    // Example validation
    if (value.trim() === "") {
      setNameError("Name is required");
    } else {
      setNameError("");
    }
  };

  const addMoreMarksheet = () => {
    setMarksheetSections((prevSections) => prevSections + 1); // Increment the number of marksheet sections
  };

  return (
    <>
      <div className="row p-0 m-0 document h-100 w-100">
        <div className="heading col-12 py-2">
          Marksheet{" "}
          <span>
            <img
              src={InfoIcon}
              alt="InfoIcon"
              data-bs-toggle="tooltip"
              title="Marksheet Document"
            />
          </span>
        </div>
        {/* Render marksheet sections */}
        {[...Array(marksheetSections)].map((_, index) => (
          <div key={index} className="marksheet col-12 row p-0 m-0">
            <div className="col-12 py-3 sub-heading">Marksheet {index + 1}</div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <TextInput
                label="Full Name"
                value={name}
                onChange={handleNameChange}
                error={nameError}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <TextInput
                label="Registration No."
                value={name}
                onChange={handleNameChange}
                error={nameError}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <Dropdown
                label="Semester"
                options={["1", "2", "3", "4", "5", "6", "7", "8"]}
                onChange={(e) => setQualificationDegree(e.target.value)}
              />
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12">
              <Dropdown
                label="Year"
                options={[
                  "2001",
                  "2002",
                  "2003",
                  "2004",
                  "2005",
                  "2006",
                  "2007",
                  "2008",
                  "2009",
                ]}
                onChange={(e) => setQualificationDegree(e.target.value)}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <TextInput
                label="Semester/Trimester"
                value={name}
                onChange={handleNameChange}
                error={nameError}
              />
            </div>
          </div>
        ))}
        <div className="col-12 py-2 pb-4">
          {/* Attach the function to the "+ Add More" button */}
          <div className="btn btn-primary" onClick={addMoreMarksheet}>
            + Add More
          </div>
        </div>
      </div>
    </>
  );
};

export default Marksheet;
